const { numberFormat } = require('app/util/formaters')

function PriceLine (props) {
  const { title, description, value } = props

  return (
    <div className='price-line'>
      <div className='line-header'>
        {title}
        <span>{description}</span>
      </div>
      <div className='line-body'>{numberFormat(value)}</div>
    </div>
  )
}

module.exports = PriceLine
